export const locationsData = [
  {
    cityKey: "locations.city.taipei",
    typeKey: "locations.card.type1",
    addressKey: "locations.address.taipei",
    icon: "ri-building-2-line",
  },
  {
    cityKey: "locations.city.hsinchu",
    typeKey: "locations.card.type2",
    addressKey: "locations.address.hsinchu",
    icon: "ri-building-2-line",
  },
  {
    cityKey: "locations.city.taichung1",
    typeKey: "locations.card.type3",
    addressKey: "locations.address.taichung1",
    icon: "ri-pencil-ruler-2-line",
  },
  {
    cityKey: "locations.city.taichung2",
    typeKey: "locations.card.type4",
    addressKey: "locations.address.taichung2",
    icon: "ri-hammer-line",
  },
  {
    cityKey: "locations.city.taichung3",
    typeKey: "locations.card.type5",
    addressKey: "locations.address.taichung3",
    icon: "ri-settings-3-line",
  },
  {
    cityKey: "locations.city.tainan",
    typeKey: "locations.card.type6",
    addressKey: "locations.address.tainan",
    icon: "ri-building-2-line",
  },
  {
    cityKey: "locations.city.pingtung",
    typeKey: "locations.card.type7",
    addressKey: "locations.address.pingtung",
    icon: "ri-building-2-line",
  },
];

export const consultScenarios = [
  { textKey: "locations.scenarios.card1", icon: "ri-map-pin-2-line" },
  { textKey: "locations.scenarios.card2", icon: "ri-home-4-line" },
  { textKey: "locations.scenarios.card3", icon: "ri-building-3-line" },
  { textKey: "locations.scenarios.card4", icon: "ri-calculator-line" },
];

export const prepItems = [
  "locations.prep.item1",
  "locations.prep.item2",
  "locations.prep.item3",
  "locations.prep.item4",
  "locations.prep.item5",
  "locations.prep.item6",
];

export const mapEmbedUrl =
  "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3740000!2d120.5!3d23.8!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1szh-TW!2stw!4v1700000000000";

export const heroBg =
  "https://readdy.ai/api/search-image?query=Stunning%20panoramic%20aerial%20view%20of%20modern%20Taiwanese%20city%20skyline%20at%20golden%20hour%20with%20contemporary%20steel-frame%20residential%20buildings%20and%20commercial%20towers%2C%20warm%20sunset%20light%20creating%20a%20golden%20glow%20over%20the%20urban%20landscape%2C%20mountains%20visible%20in%20the%20distance%2C%20professional%20cityscape%20architectural%20photography%2C%20clean%20and%20premium%20atmosphere%2C%20no%20text%20no%20logos%2C%20graphite%20and%20warm%20amber%20tones%20dominating%20the%20scene&width=1920&height=700&seq=locations-hero&orientation=landscape";